// ─────────────────────────────────────────────────────────────────────────────
// Mock Patient Data — matches shape of API_PATHS.PATIENT_LIST response
// Used in: AllPatient.jsx, InnerAppointment.jsx (patient dropdown)
// ─────────────────────────────────────────────────────────────────────────────

export const mockPatientListResponse = {
  rescode: 1,
  message: "Patient list fetched successfully",
  data: {
    userCount: 12,
    users: [
      {
        UserId: 101,
        FirstName: "Aryan",
        LastName: "Sharma",
        Phone: "9876543210",
        Email: "aryan.sharma@gmail.com",
        address: "12, Ganesh Nagar, Jaipur, Rajasthan",
        gender: "Male",
        dob: "2018-04-15",
        motherName: "Priya Sharma",
        fatherName: "Rajesh Sharma",
        symptomsDescription: "Speech delay, difficulty in communication",
        IsActive: 1,
        joining_date: "2024-01-10",
        payment: "Paid",
      },
      {
        UserId: 102,
        FirstName: "Sneha",
        LastName: "Verma",
        Phone: "9812345678",
        Email: "sneha.verma@gmail.com",
        address: "45, Vaishali Nagar, Jaipur, Rajasthan",
        gender: "Female",
        dob: "2019-07-22",
        motherName: "Anita Verma",
        fatherName: "Suresh Verma",
        symptomsDescription: "Autism spectrum disorder, social interaction difficulties",
        IsActive: 1,
        joining_date: "2024-02-14",
        payment: "Pending",
      },
      {
        UserId: 103,
        FirstName: "Rohan",
        LastName: "Gupta",
        Phone: "9998877665",
        Email: "rohan.gupta@gmail.com",
        address: "7, Civil Lines, Jaipur, Rajasthan",
        gender: "Male",
        dob: "2017-11-03",
        motherName: "Meena Gupta",
        fatherName: "Anil Gupta",
        symptomsDescription: "ADHD, hyperactivity and attention issues",
        IsActive: 1,
        joining_date: "2024-03-01",
        payment: "Paid",
      },
      {
        UserId: 104,
        FirstName: "Pooja",
        LastName: "Mishra",
        Phone: "9123456789",
        Email: "pooja.mishra@gmail.com",
        address: "33, Malviya Nagar, Jaipur, Rajasthan",
        gender: "Female",
        dob: "2020-01-30",
        motherName: "Sunita Mishra",
        fatherName: "Dinesh Mishra",
        symptomsDescription: "Developmental delay, motor skill difficulties",
        IsActive: 1,
        joining_date: "2024-04-05",
        payment: "Partial",
      },
      {
        UserId: 105,
        FirstName: "Kabir",
        LastName: "Singh",
        Phone: "9654321098",
        Email: "kabir.singh@gmail.com",
        address: "89, Tonk Road, Jaipur, Rajasthan",
        gender: "Male",
        dob: "2016-08-18",
        motherName: "Rekha Singh",
        fatherName: "Harpreet Singh",
        symptomsDescription: "Dyslexia, reading and writing difficulties",
        IsActive: 0,
        joining_date: "2023-11-20",
        payment: "Paid",
      },
      {
        UserId: 106,
        FirstName: "Aaradhya",
        LastName: "Joshi",
        Phone: "9741852963",
        Email: "aaradhya.joshi@gmail.com",
        address: "22, Shyam Nagar, Jaipur, Rajasthan",
        gender: "Female",
        dob: "2018-12-09",
        motherName: "Kavita Joshi",
        fatherName: "Manoj Joshi",
        symptomsDescription: "Cerebral palsy, physiotherapy required",
        IsActive: 1,
        joining_date: "2024-05-10",
        payment: "Pending",
      },
      {
        UserId: 107,
        FirstName: "Vivaan",
        LastName: "Patel",
        Phone: "9632587410",
        Email: "vivaan.patel@gmail.com",
        address: "56, Pratap Nagar, Jaipur, Rajasthan",
        gender: "Male",
        dob: "2019-03-25",
        motherName: "Hema Patel",
        fatherName: "Chirag Patel",
        symptomsDescription: "Down syndrome, special education required",
        IsActive: 1,
        joining_date: "2024-06-15",
        payment: "Paid",
      },
      {
        UserId: 108,
        FirstName: "Ishaan",
        LastName: "Rawat",
        Phone: "9517534682",
        Email: "ishaan.rawat@gmail.com",
        address: "14, Sindhi Colony, Jaipur, Rajasthan",
        gender: "Male",
        dob: "2017-06-11",
        motherName: "Geeta Rawat",
        fatherName: "Bharat Rawat",
        symptomsDescription: "Sensory processing disorder, occupational therapy required",
        IsActive: 1,
        joining_date: "2024-07-01",
        payment: "Partial",
      },
    ],
  },
};

// ─────────────────────────────────────────────────────────────────────────────
// Mock Patient Details — matches shape of API_PATHS.PATIENT_DETAILS response
// Used in: addpatient.jsx (edit mode)
// ─────────────────────────────────────────────────────────────────────────────

export const mockPatientDetails = {
  rescode: 1,
  message: "Patient details fetched successfully",
  data: {
    UserId: 101,
    FirstName: "Aryan",
    LastName: "Sharma",
    Phone: "9876543210",
    Email: "aryan.sharma@gmail.com",
    address: "12, Ganesh Nagar, Jaipur, Rajasthan",
    gender: "Male",
    dob: "2018-04-15",
    motherName: "Priya Sharma",
    fatherName: "Rajesh Sharma",
    symptomsDescription: "Speech delay, difficulty in communication with peers",
    IsActive: 1,
    joining_date: "2024-01-10",
  },
};

// ─────────────────────────────────────────────────────────────────────────────
// Mock Patient Payment History — matches API_PATHS.PATIENT_PAYMENT_HISTORY
// ─────────────────────────────────────────────────────────────────────────────

export const mockPatientPaymentHistory = {
  rescode: 1,
  message: "Payment history fetched successfully",
  data: {
    appointment_payment_history: [
      {
        invoice_id: 1001,
        session_name: "Speech Therapy",
        session_type: "Regular",
        total_amount: 5000,
        paid_amount: 5000,
        remaining_amount: 0,
        date: "2024-12-01",
        is_full_amount_paid: 1,
      },
      {
        invoice_id: 1002,
        session_name: "Occupational Therapy",
        session_type: "MTS",
        total_amount: 8000,
        paid_amount: 4000,
        remaining_amount: 4000,
        date: "2025-01-10",
        is_full_amount_paid: 0,
      },
    ],
    recordCount: 2,
  },
};
